import localSeoPreview from '@/assets/portfolio/local-seo-preview.jpg';
import ecommerceSeoPreview from '@/assets/portfolio/ecommerce-seo-preview.jpg';
import technicalSeoPreview from '@/assets/portfolio/technical-seo-preview.jpg';
import contentSeoPreview from '@/assets/portfolio/content-seo-preview.jpg';
import internationalSeoPreview from '@/assets/portfolio/international-seo-preview.jpg';
import seoAnalyticsPreview from '@/assets/portfolio/seo-analytics-preview.jpg';

export interface Project {
  title: string;
  category: string;
  description: string;
  tags: string[];
  url: string;
  image: string;
}

// Featured projects shown on homepage (first 6)
export const featuredProjects: Project[] = [
  {
    title: 'Local SEO Optimization',
    category: 'Local SEO',
    description: 'Complete local SEO strategy that boosted local visibility by 150% and generated 3x more leads.',
    tags: ['Google My Business', 'Local Citations', 'Maps SEO'],
    url: '/projects/local-seo',
    image: localSeoPreview,
  },
  {
    title: 'E-commerce SEO Campaign',
    category: 'E-commerce SEO',
    description: 'Full-scale SEO campaign resulting in 250% organic traffic increase and $500+ monthly revenue.',
    tags: ['Product SEO', 'Schema Markup', 'Link Building'],
    url: '/projects/ecommerce-seo',
    image: ecommerceSeoPreview,
  },
  {
    title: 'Technical SEO Audit',
    category: 'Technical SEO',
    description: 'Comprehensive site audit that recovered 35% lost traffic and improved page speed by 45%.',
    tags: ['Core Web Vitals', 'Site Speed', 'Crawlability'],
    url: '/projects/technical-seo',
    image: technicalSeoPreview,
  },
  {
    title: 'Content Strategy & SEO',
    category: 'Content SEO',
    description: 'Data-driven content strategy that increased rankings for 150+ keywords with 200% traffic growth.',
    tags: ['Keyword Research', 'Content Gap', 'Topic Clusters'],
    url: '/projects/content-seo',
    image: contentSeoPreview,
  },
  {
    title: 'International SEO',
    category: 'Global SEO',
    description: 'Multi-country SEO implementation across 5 countries with 300% international traffic growth.',
    tags: ['Hreflang', 'Multi-language', 'Geo-targeting'],
    url: '/projects/international-seo',
    image: internationalSeoPreview,
  },
  {
    title: 'SEO Analytics Dashboard',
    category: 'SEO Analytics',
    description: 'Custom analytics dashboard for tracking SEO KPIs across 10+ client websites.',
    tags: ['Google Analytics', 'Data Studio', 'Reporting'],
    url: '/projects/seo-analytics',
    image: seoAnalyticsPreview,
  },
];

// All projects (add more here in the future)
export const allProjects: Project[] = [
  ...featuredProjects,
  // Add more projects here as needed
];
